import { TMessage, TMessageSchema } from '../../types/messages';
import { isMessageRead } from './isMessageRead';
import { mapCommonMessageFields } from './mapCommonMessageFields';

export function mapMessageToIncoming(existingMessage: TMessage, rawMessage: TMessageSchema): TMessage {
  const message = mapCommonMessageFields(rawMessage, existingMessage);
  const isRead = isMessageRead({ rawMessage, isOutcoming: false });

  return {
    ...message,
    isRead,
    status: undefined,
  };
}
